// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0d308329","239":"214282d2","455":"1cefc26e"}[chunkId] + ".chunk.js";
};